<div class="main-wrapper">
    <div class="glass-card">
        <div class="logo-header mb-4 mt-2">
            <img src="assets/images/magno/logo.png" alt="Sorteo Anáhuac" class="main-logo d-block mx-auto" style="max-width: 200px;">
        </div>
        <div class="brand-logo">
            <i class="fas" [ngClass]="{'fa-user': step === 'email' || step === 'password', 'fa-user-plus': step === 'set_password', 'fa-shield-alt': step === 'verification'}"></i>
        </div>
        <h2 class="black">
            <span *ngIf="step === 'set_password'">Crea tu clave</span>
            <span style="font-weight: 900;" *ngIf="step !== 'set_password'">{{ step === 'verification' ? 'Seguridad' : 'Bienvenido' }}</span>
        </h2>
        <p class="subtitle">
            <span *ngIf="step === 'email'">Ingresa a tu wallet</span>
            <span *ngIf="step === 'password'">Ingresa tu contraseña</span>
            <span *ngIf="step === 'set_password'">Define una contraseña para tu cuenta</span>
            <span *ngIf="step === 'verification'">Escribe el código de 8 dígitos enviado a tu correo</span>
        </p>
        <div *ngIf="errorMessage" class="alert alert-danger small py-2 mb-3">
            <i class="fas fa-exclamation-circle mr-1"></i> {{ errorMessage }}
        </div>
        <form #f="ngForm" (ngSubmit)="onNextStep(f)">
            <div class="form-group" *ngIf="step === 'email'">
                <i class="fas fa-envelope input-icon"></i>
                <input type="email" name="email" class="form-control input-orange" placeholder="Correo electrónico" [(ngModel)]="loginData.email" required email>
            </div>
            <div class="form-group" *ngIf="step === 'password'">
                <i class="fas fa-lock input-icon"></i>
                <input type="password" name="password" class="form-control" placeholder="Contraseña" [(ngModel)]="loginData.password" required>
            </div>
            <div *ngIf="step === 'set_password'">
                <div class="form-group">
                    <i class="fas fa-lock input-icon"></i>
                    <input type="password" name="password" class="form-control" placeholder="Nueva contraseña" [(ngModel)]="loginData.password" required minlength="8">
                </div>
                <div class="form-group">
                    <i class="fas fa-check-double input-icon"></i>
                    <input type="password" name="confirmPassword" class="form-control" placeholder="Repite tu contraseña" [(ngModel)]="loginData.confirmPassword" required>
                </div>
            </div>
            <div class="form-group" *ngIf="step === 'verification'">
                <i class="fas fa-key input-icon"></i>
                <input type="text" name="code" class="form-control text-center" style="letter-spacing: 5px; font-weight: bold;" placeholder="00000000" [(ngModel)]="loginData.code" required minlength="8" maxlength="8">
            </div>
            <button type="submit" class="btn btn-login" [disabled]="f.invalid || loading">
                <span *ngIf="!loading">{{ step === 'email' ? 'Siguiente' : (step === 'verification' ? 'Acceder' : 'Continuar') }} <i class="fas fa-arrow-right ml-2 small"></i></span>
                <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
            </button>
            <button type="button" (click)="goBack()" *ngIf="step !== 'email' && !loading" class="btn btn-link btn-sm mt-3 text-muted w-100">
                <i class="fas fa-chevron-left mr-1"></i> Volver atrás
            </button>
        </form>
    </div>
</div>